import AsyncStorage from '@react-native-async-storage/async-storage';

const DIAGRAM_SESSION_KEY = 'diagram-spec-session-v1';

export type PersistedDiagramSession = {
  diagramId: string;
  revisionId: string;
  imageRef: string;
  updatedAt: string;
};

export const saveDiagramSession = async (session: PersistedDiagramSession): Promise<void> => {
  await AsyncStorage.setItem(DIAGRAM_SESSION_KEY, JSON.stringify(session));
};

export const loadDiagramSession = async (): Promise<PersistedDiagramSession | null> => {
  const raw = await AsyncStorage.getItem(DIAGRAM_SESSION_KEY);
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw) as Partial<PersistedDiagramSession>;
    if (typeof parsed.diagramId !== 'string' || typeof parsed.revisionId !== 'string' || typeof parsed.imageRef !== 'string') {
      return null;
    }
    return {
      diagramId: parsed.diagramId,
      revisionId: parsed.revisionId,
      imageRef: parsed.imageRef,
      updatedAt: typeof parsed.updatedAt === 'string' ? parsed.updatedAt : '',
    };
  } catch {
    return null;
  }
};

export const clearDiagramSession = async (): Promise<void> => {
  await AsyncStorage.removeItem(DIAGRAM_SESSION_KEY);
};
